import Text from '@deprecated-ui/common/Text';
import Button from '@deprecated-ui/common/Button';
import color from '@deprecated-ui/_style/color';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { effects as moderationEffects } from 'lib/entities/moderation';
import { useQueryClient } from '@tanstack/react-query';
import QueryProvider from 'global/QueryProvider';
import { Modal } from './styled';

function ModalBlockUser({ username, userId, onCancel, ...props }) {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();

  /**
   * @param {Event} e
   */
  const handleBlock = async (e) => {
    e.stopPropagation();
    const block = await dispatch(moderationEffects.blockUser(userId));
    const { error } = block.payload;
    queryClient.invalidateQueries();

    if (!error) {
      onCancel(e);
    }
  };

  return (
    <Modal
      {...props}
      onCancel={onCancel}
      title={
        <Text size="16px" height="40px" weight="bold" color={color.black}>
          Block User
        </Text>
      }
      centered
      footer={[
        <Button key="cancel" block height="40px" onClick={onCancel}>
          <Text align="center">Cancel</Text>
        </Button>,
        <Button
          key="confirm"
          block
          type="primary"
          height="40px"
          margin="0px !important"
          onClick={handleBlock}
        >
          <Text align="center" color={color.light}>
            Block
          </Text>
        </Button>,
      ]}
      width={432}
    >
      <Text align="center">
        You are about to block {username}. Do you want to proceed?
      </Text>
    </Modal>
  );
}

ModalBlockUser.propTypes = {
  username: PropTypes.string.isRequired,
  userId: PropTypes.number.isRequired,
  onCancel: PropTypes.func,
};

ModalBlockUser.defaultProps = {
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onCancel: () => {},
};

function ModalBlockWithQuery({ username, userId, onCancel, ...props }) {
  return (
    <QueryProvider>
      <ModalBlockUser
        username={username}
        userId={userId}
        onCancel={onCancel}
        {...props}
      />
    </QueryProvider>
  );
}

export default ModalBlockWithQuery;
